import { FONT_LOAD_SAMPLE_TEXT } from 'shared/fonts';

/**
 * Waits for every face a scene draws with — canvas text does not wait for a font: drawn before it is loaded, it
 * falls back silently and the frame is baked into the video that way (MDN, CSS Font Loading API).
 *
 * `fonts` are canvas `font` strings (`'900 150px Unbounded'`), one per weight and style; the families come from the
 * Google Fonts link the app adds on start (`shared/fonts/load-app-fonts.ts`). Resolves with the faces that are still
 * missing afterwards — the scene is drawn anyway with a fallback, the caller decides whether to say so.
 */
export async function loadSceneFonts(fonts: readonly string[], fontSet: FontFaceSet = document.fonts): Promise<string[]> {
  await Promise.all(fonts.map((font) => fontSet.load(font, FONT_LOAD_SAMPLE_TEXT).catch(() => [])));
  return fonts.filter((font) => !fontSet.check(font, FONT_LOAD_SAMPLE_TEXT));
}
